/**
 * A path the app does not have a screen for.
 */

import { useNavigate } from 'react-router-dom'
import SearchOffIcon from '@mui/icons-material/SearchOff'
import EmptyState from '../components/common/EmptyState'

export default function NotFound() {
  const navigate = useNavigate()
  return (
    <EmptyState
      icon={<SearchOffIcon />}
      title="No such page"
      description="That address does not match anything in BEST."
      actions={[{ label: 'Go to the dashboard', onClick: () => navigate('/') }]}
    />
  )
}
